import React from 'react';
import _ from 'lodash';
import { Row } from "components/shared/layout";
import Button from "components/button";
import actionContext from "./action-context/index";
import styled from "styled-components";
import queries, { maxQuery } from "utils/responsivenessHelper";

const ButtonWrapper = styled.div`
  margin: 25px auto;
  button {
    min-width: 13.75em;
  }
`;

const RightWrapper = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 15px;

  button {
    min-width: 12.3125em;
  }
`;

const RightWrapperInner = styled(Row)`
  ${maxQuery.both({ margin: '20px auto' }, "850px")}
`;

const Left = styled(Row)`
  display: flex;
  width: 100%;

  ${queries.both({ flexWrap: "unset" })}
`;

const ActionButtons = styled.div`
  display: inline-flex;
  float: left;
  margin-left: 15px;
`;

const SubmissionButtons = ({
  rest,
  questions,
  isSubmitted,
  isCredited,
  onClickSubmit,
}) => {

  function isAllFieldsCompleted(values) {
    const valuesForThisLevel = _.pick(values, _.keys(questions));
    if (_.every(_.values(valuesForThisLevel), val => !_.isEmpty(val) || (_.isEmpty(val) && _.isDate(val)))) {
      return true;
    }

    return false;
  };

  return (
    <ActionButtons>
      <RightWrapper alignItems="center">
        <RightWrapperInner>
          {actionContext(rest)}
        </RightWrapperInner>
      </RightWrapper>
      {isSubmitted
        ? (<div>
            {isCredited 
              ? (<ButtonWrapper>
                  <Button
                    variant='zltoDarkBlue'
                    disabled
                  >
                    Already Earned Zlto
                  </Button>
                </ButtonWrapper>
              )
            :(<ButtonWrapper>
                  <Button
                    variant='zltoDarkBlue'
                    disabled
                  >
                    Already Submitted
                  </Button>
                </ButtonWrapper>
            )}
          </div>
        )
        : (
          <>
            {isAllFieldsCompleted(rest.values) &&
              <ButtonWrapper>
                <Button
                  variant='zltoDarkBlue'
                  onClick={() => { onClickSubmit(rest.values) }}
                >
                  Submit for Zlto
                </Button>
              </ButtonWrapper>
            }
          </>
        )
      }
    </ActionButtons>
  )

};

export default SubmissionButtons;
